export default __webpack_public_path__ + "static/media/isFile.afff8128.svg";